<div class="row p-4">  
 <ng-container *ngIf=" grpName === 'POLICE PERMIT' ; else firePermits">
  <span class="col-md-12 text-right boldlbl">Page 4 of 10</span>  
  </ng-container>
  <ng-template #firePermits>
  <span class="col-md-12 text-right boldlbl">Page 5 of 10</span> 
  </ng-template>
</div>
<div>
    <br>
</div>
<div class="text-center">

    <h3>{{eAppRegConstant.PageHeader}}</h3>
    <h4><br />
        {{grpName | titlecase}} Questionnaire</h4>
    <ng-container *ngIf="notes">
        <h4>{{notes}}</h4>
    </ng-container>

</div>
<div>
    <br>
</div>
<form [formGroup]="permitForm" (ngSubmit)="eappreg_permit_questions_action();">
<div class="card">
    <div class="card-body">
        <table id="permit_table" class="table table-bordered">

            <!--- Loops thru questions in group --->
            <jhi-dsp-questions-answers [qQuestions]="qQuestions" [parentForm]="permitForm" [DispOnlyInd]="DispOnlyInd"
                [DispSeqInd]="DispSeqInd" (answerAdded)="update($event)" (parentChildList)="loadParentChildList($event)"
                style="display:contents">
            </jhi-dsp-questions-answers>
        </table>
    </div>
</div>
<div>
    <br>
</div>
<div class="text-center">
    <input type="button" class="btn btn-primary text-center" (click)="back()" value="Back"/>
    <button class="btn btn-primary" type="submit">Accept and Proceed</button>
</div>
<div>
    <br>
</div>
</form>